import styled from 'styled-components';

import { AdvancePaymentStatusText } from '~libs.desktop.shared.appointment-advance-payment';

import { PriceText } from '../../../../../../visitSettlement/shared/price/PriceText';

export const StyledPaidAmountText = styled(PriceText)`
   color: ${(props) => props.theme.placeholder};
`;

StyledPaidAmountText.displayName = 'StyledPaidAmountText';

export const StyledRequiredAmountText = styled(PriceText)`
   color: ${(props) => props.theme.placeholder};
`;

StyledRequiredAmountText.displayName = 'StyledRequiredAmountText';

export const StyledAdvancePaymentStatusText = styled(AdvancePaymentStatusText)`
   font-size: 12px;
`;
StyledAdvancePaymentStatusText.displayName = 'StyledAdvancePaymentStatusText';
